<template>
  <div class="bg-tealgray650 pt-3 pt-xl-5 pb-3 pb-xl-0">
    <b-container>
      <div class="d-sm-flex justify-content-between align-items-end pb-3">
        <!-- Logo Section -->
        <div v-if="$route.name === 'Main'" class="cursor" style="max-width: 200px">
          <b-img src="/static_img/logos/QESG_flat-v3.svg" style="max-height: 33.6px" />
        </div>
        <div v-else class="d-flex align-items-end justify-content-between">
          <div variant="icon" class="cursor" style="max-width: 200px" @click="goToMain">
            <b-img src="/static_img/logos/QESG_flat-v3.svg" style="max-height: 33.6px" />
          </div>
          <h4
            v-if="show_landing_menu !== true && report_code !== '' && selected_report"
            class="mb-0 pl-1 pl-xl-2 d-none d-xl-inline fw-400 gray-400"
          >
            {{ selected_report.report_name }}
            <b-badge v-if="selected_report.sample_report" variant="info" class="mr-2"
              >sample</b-badge
            >
            <b-badge v-if="is_admin === 4">
              {{ selected_report.report_code }}
            </b-badge>
            <b-icon
              v-if="selected_report.is_able_to_edit"
              scale="1"
              class="ml-2"
              variant="success"
              icon="check-circle"
              aria-hidden="true"
            />
            <b-icon
              v-else
              v-b-tooltip.hover="'읽기 권한만 있음. 결제 후 편집 및 공개 가능합니다.'"
              class="ml-2"
              variant="danger"
              icon="x-circle"
              aria-hidden="true"
            />
          </h4>
        </div>

        <!-- User Information and Actions -->
        <div class="d-flex justify-content-end">
          <div class="d-none d-xl-block">
            <div
              v-if="
                licenseInfo &&
                licenseInfo.available_report_cnt_info &&
                show_landing_menu &&
                $route.name === 'Main'
              "
              v-b-tooltip.hover
              class="py-1 px-2 mr-2 center"
              style="color: white; font-size: 0.9rem; width: fit-content"
              :title="`${licenseInfo?.service_info?.product_name} 플랜 이용 중`"
            >
              안녕하세요 {{ user_name }}님
              {{ licenseInfo.available_report_cnt_info.remain_report_cnt }}개 보고서를 추가로 생성할
              수 있습니다.
            </div>

            <div
              v-else-if="licenseInfo === null && show_landing_menu && $route.name === 'Main'"
              class="py-1 px-2 mr-2 center"
              style="color: white; font-size: 0.9rem; width: fit-content"
            >
              안녕하세요 {{ user_name }}님.
              <router-link to="/payment_service"> 결제 </router-link>후 보고서 생성이 가능합니다.
            </div>
          </div>

          <!-- Action Buttons -->
          <b-button
            id="bell"
            v-b-tooltip.hover
            variant="half-bg-light"
            class="py-1 px-2"
            aria-controls="notice-sidebar"
            title="공지 및 로그"
            @click="$emit('toggle-notice-sidebar')"
          >
            <fa id="bell" :icon="['far', 'bell']" />
            <div v-if="new_notice" class="red custom-position">●</div>
          </b-button>
          <b-button
            id="my-info"
            :variant="is_confirmed ? 'half-bg-light' : 'red'"
            class="py-1 px-2 ml-2"
            @click.stop="$emit('show-my-info')"
          >
            <fa :icon="['far', 'user']" />
          </b-button>
          <b-button
            id="my-payment"
            v-b-tooltip.hover
            :variant="payment_active ? 'light' : 'half-bg-light'"
            class="py-1 px-2 ml-2"
            title="결제 정보"
            @click.stop="$router.push({ name: 'PaymentService' })"
          >
            <b-icon icon="credit-card" />
          </b-button>
          <b-dropdown
            id="manual-dropdown"
            v-model="manual_active"
            v-b-tooltip.hover
            :variant="manual_active ? 'light' : 'half-bg-light'"
            toggle-class="py-1 px-2 ml-2"
            no-caret
            title="매뉴얼"
            right
          >
            <template #button-content>
              <b-icon icon="list-ul" />
            </template>
            <b-dropdown-item
              v-for="item in filteredManualItems"
              :key="item.text"
              :href="item.link"
              target="_blank"
            >
              {{ item.text }}
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            v-if="is_admin === 4"
            variant="icon-light"
            class="py-1 px-2 ml-2"
            @click="$router.push({ name: 'AllReports' })"
          >
            관리자
          </b-button>
          <b-button variant="icon-light" class="py-1 px-2 ml-2" @click="logout">
            로그아웃
          </b-button>
        </div>
      </div>

      <!-- Mobile View -->
      <div class="d-block d-xl-none">
        <div
          v-if="
            licenseInfo &&
            licenseInfo.available_report_cnt_info &&
            show_landing_menu &&
            $route.name === 'Main'
          "
          v-b-tooltip.hover
          class="py-1 px-2 mr-2 center"
          style="color: white; font-size: 0.9rem; width: fit-content"
          :title="`${licenseInfo?.service_info?.product_name} 플랜 이용 중`"
        >
          안녕하세요 {{ user_name }}님
          {{ licenseInfo.available_report_cnt_info.remain_report_cnt }}개 보고서를 추가로 생성할 수
          있습니다.
        </div>

        <div
          v-else-if="licenseInfo === null && show_landing_menu && $route.name === 'Main'"
          class="py-1 px-2 mr-2 center"
          style="color: white; font-size: 0.9rem; width: fit-content"
        >
          안녕하세요 {{ user_name }}님. <router-link to="/payment_service"> 결제 </router-link>후
          보고서 생성이 가능합니다.
        </div>
      </div>

      <!-- Report Name for Mobile -->
      <h4
        v-if="$route.name !== 'Main' && !show_landing_menu && report_code !== '' && selected_report"
        class="mb-2 mb-sm-0 pl-1 pl-xl-2 d-inline d-xl-none fw-400 gray-400"
      >
        <b-badge v-if="selected_report.sample_report" variant="info" class="mr-1">sample</b-badge>
        <b-badge v-if="is_admin === 4">
          {{ selected_report.report_code }}
        </b-badge>
        {{ selected_report.report_name }}
        <b-icon
          v-if="selected_report.is_able_to_edit"
          scale="1"
          variant="success"
          icon="check-circle"
          aria-hidden="true"
        />
        <b-icon
          v-else
          v-b-tooltip.hover="'읽기 권한만 있음. 결제 후 편집 및 공개 가능합니다.'"
          variant="danger"
          icon="x-circle"
          aria-hidden="true"
        />
      </h4>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import LogAndNotice from './LogAndNotice';
import Notice from './Notice.js';

export default {
  name: 'TopHeader',
  components: {
    LogAndNotice
  },
  mixins: [Notice],
  props: {
    payment_active: { type: Boolean, default: false },
    manual_active: { type: Boolean, default: false },
    show_landing_menu: { type: Boolean, default: true }
  },
  data() {
    return {
      manualItems: [
        {
          text: '사용 매뉴얼',
          link: 'https://report.qesg.co.kr/document/QESG_ESG_Reporting_Tool_사용매뉴얼_기능설명_2024_10_v2.pdf'
        },
        {
          text: '패치노트',
          link: 'https://qesg.notion.site/ESG-Reporting-Tool-1e477f7d74ca80749991fe2bbcd914a5'
        },
        {
          text: '관리자용 설명서',
          link: 'https://www.notion.so/qesg/Q-A-1e477f7d74ca80b9b1b9d0c46e465570'
        }
      ]
    };
  },
  computed: {
    ...mapState(['user_id', 'is_confirmed', 'is_admin', 'user_name', 'licenseInfo', 'e_mail']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['report_code', 'standard_mode']),
    ...mapState('logs', ['activity_logs', 'activity_logs_loaded', 'new_notice', 'mention_list']),
    filteredManualItems() {
      return this.manualItems.filter(
        item => item.text !== '관리자용 설명서' || this.is_admin === 4
      );
    }
  },
  methods: {
    ...mapActions(['logout']),
    ...mapActions('logs', ['readNoticesByUser']),
    goToMain() {
      this.$store.commit('headerDropdown/SET_SHOW_BUTTONS1', true);
      this.$store.commit('headerDropdown/SET_SHOW_BUTTONS2', false);
      this.$store.commit('headerDropdown/SET_SHOW_BUTTONS3', false);
      this.$router.push({ name: 'Main' });
    }
  },
  mounted() {
    this.readNoticesByUser({ user_email: this.e_mail });
  }
};
</script>

<style scoped>
#bell {
  position: relative;
}
.custom-position {
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(50%, -50%);
}
</style>
